import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { RedirectService } from '../services/redirect.service';

export const externalRedirectGuard: CanActivateFn = route => {
  const redirectService = inject(RedirectService);
  const redirectTo = route.data?.['redirectTo'];
  if (redirectTo) {
    return redirectService.externalRedirectTo(redirectTo);
  }
  return true;
};
